const TAX_MODE_CONSTANTS = {
  CREATE_TAX_MODE_REQUEST: 'CREATE_TAX_MODE_REQUEST',
  CREATE_TAX_MODE_SUCCESS: 'CREATE_TAX_MODE_SUCCESS',
  CREATE_TAX_MODE_FAIL: 'CREATE_TAX_MODE_FAIL',
  CREATE_TAX_MODE_RESET: 'CREATE_TAX_MODE_RESET',

  GET_ALL_TAX_MODES_REQUEST: 'GET_ALL_TAX_MODES_REQUEST',
  GET_ALL_TAX_MODES_SUCCESS: 'GET_ALL_TAX_MODES_SUCCESS',
  GET_ALL_TAX_MODES_FAIL: 'GET_ALL_TAX_MODES_FAIL',
  GET_ALL_TAX_MODES_RESET: 'GET_ALL_TAX_MODES_RESET',

  UPDATE_TAX_MODE_REQUEST: 'UPDATE_TAX_MODE_REQUEST',
  UPDATE_TAX_MODE_SUCCESS: 'UPDATE_TAX_MODE_SUCCESS',
  UPDATE_TAX_MODE_FAIL: 'UPDATE_TAX_MODE_FAIL',
  UPDATE_TAX_MODE_RESET: 'UPDATE_TAX_MODE_RESET',

  DELETE_TAX_MODE_REQUEST: 'DELETE_TAX_MODE_REQUEST',
  DELETE_TAX_MODE_SUCCESS: 'DELETE_TAX_MODE_SUCCESS',
  DELETE_TAX_MODE_FAIL: 'DELETE_TAX_MODE_FAIL',

  CLEAR_ERRORS: 'CLEAR_ERRORS',
}
export default TAX_MODE_CONSTANTS
